import { roleLabelMap } from 'Admin/Users/components';
import { PortalUserGrant } from 'Admin/Users/types';
import { snakeToTitleCase } from 'Shared/utils';

export const getRoleFromGrants = (
  grants: Array<PortalUserGrant>,
  partnerId?: string
): string => {
  const order = Object.keys(roleLabelMap);
  const scopedGrants = partnerId
    ? grants.filter(
        grant =>
          grant.scope === 'partner' &&
          grant.scopeId === partnerId &&
          grant.role.name !== 'unlicensed_quoting_user'
      )
    : grants.filter(
        grant =>
          grant.scope === 'system' &&
          grant.role.name !== 'unlicensed_quoting_user'
      );

  return scopedGrants
    .sort((a, b) => order.indexOf(a.role.name) - order.indexOf(b.role.name))
    .map(grant => snakeToTitleCase(grant.role.name))
    .join(', ');
};

export type AuthorizationsToSellType = {
  authorizedState: string;
  isAuthorized: boolean;
};
export const formatAuthorizedStates = (
  authorizeState: Array<AuthorizationsToSellType>
) =>
  authorizeState
    .filter(el => el.isAuthorized)
    .map(el => el.authorizedState)
    .sort()
    .join(', ');
